const trimRightSlash = (s) => (s || '').replace(/\/+$/, '');

const config = {
  apiUrl: process.env.VUE_APP_API_URL || 'https://payments.cmglobals.com/api/v1',
  baseUrl: process.env.VUE_APP_BASE_URL || 'https://payments.cmglobals.com',
  mediaUrl: trimRightSlash(process.env.VUE_APP_MEDIA_URL || 'https://payments.cmglobals.com'),
};

export default config;
